module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-14-064e17a938fe1ef6f221a59591d9fd3f.jpg";